import { Button } from './Button';

export function NotFoundComponent() {
	return (
		<div className="flex h-full flex-col items-center justify-center">
			<h2 className="text-6xl font-bold">404</h2>
			<p className="opacity-80">Page not found</p>
			<Button to="/" className="mt-4">
				Return to home
			</Button>
		</div>
	);
}
